<template>
	<div class="full-width">
		<v-tabs
			dark
			v-model="activeTab"
			slider-color="yellow"
			:color="themeInputColor"
		>
			<v-tab
				v-for="(tab, i) in tabs"
				:key="i"
				:href="'#tab-' + i"
				:ripple="false"
				class="px-3"
			>
				{{ tab.name }}
			</v-tab>
		</v-tabs>
		<v-tabs-items v-model="activeTab">
			<v-tab-item value="tab-0">
				<v-container align-center>
					<v-layout justify-center>
						<v-flex>
							<v-layout justify-center row wrap>
								<v-flex>
									<v-autocomplete
										v-model="selectedYear"
										label="Select Year"
										:items="filterYears"
										:autcomplete="false"
										placeholder="Year"
										class="text-field-wrapper pt-4"
										clearable
									/>
								</v-flex>
								<v-flex>
									<v-autocomplete
										v-model="selectedMonth"
										label="Select Month"
										:items="filterMonths"
										:autcomplete="false"
										placeholder="Month"
										class="text-field-wrapper pt-4"
										clearable
									/>
								</v-flex>
							</v-layout>
							<v-layout justify-center>
								<v-btn
									round
									:dark="!!selectedYear && !!selectedMonth"
									:color="themeInputColor"
									:disabled="!selectedYear || !selectedMonth"
									:loading="isInvoiceFetching"
									@click="getInvoices"
								>
									Get Approved Invoices
								</v-btn>
							</v-layout>
							<v-data-table
								:headers="headers"
								:items="approvedInvoices"
								class="elevation-1 mt-4"
								:hide-actions="true"
							>
								<template v-slot:items="props">
									<tr>
										<td class="text-xs-center">
											{{ props.item.retailerName }}
										</td>
										<td class="text-xs-center">
											{{ props.item.dstrId }}
										</td>
										<td class="text-xs-center">
											{{ props.item.city }}
										</td>
										<td class="text-xs-center">
											{{ props.item.state }}
										</td>
										<td
											@click="viewInvoice(props.item)"
											class="text-xs-center"
										>
											<v-icon>visibility</v-icon>
										</td>
										<td
											@click="downloadInvoice(props.item)"
											class="text-xs-center"
										>
											<v-icon>download</v-icon>
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-flex>
					</v-layout>
					<v-dialog persistent v-model="viewInvoiceModal">
						<pdf
							v-if="invoicePath"
							:src="{
								url: invoicePath
							}"
							:key="invoicePath"
							:resize="true"
						>
							<template slot="loading">
								loading content here...
							</template>
						</pdf>
						<v-layout class="white">
							<v-btn @click="downloadPdf" color="success"
								>Download</v-btn
							>
							<v-btn @click="closeInvoiceModal" color="error"
								>Close</v-btn
							>
						</v-layout>
					</v-dialog>
				</v-container>
			</v-tab-item>
			<v-tab-item value="tab-1">
				<dstr-support-invoice-upload
					:title="tabs[1].name"
					:themeInputColor="themeInputColor"
				/>
			</v-tab-item>
		</v-tabs-items>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { FETCH_DSTR_PENDING_SUPPORT_ENTRIES } from "../../store/action-types";
import { THEME_INPUT_COLOUR, MONTHS, YEARS } from "../constants";
import { __fileDownload } from "../../utils";
import pdf from "pdfvuer";
import dstrSupportInvoiceUpload from "./dstr-support-invoice-upload.vue";

export default {
	components: {
		pdf,
		"dstr-support-invoice-upload": dstrSupportInvoiceUpload
	},
	data() {
		return {
			MONTHS,
			YEARS,
			themeInputColor: THEME_INPUT_COLOUR,
			selectedMonth: "",
			selectedYear: "",
			isInvoiceFetching: false,
			approvedInvoices: [],
			headers: [
				{
					text: "Distributor Name",
					value: "retailerName",
					align: "center",
					sortable: false
				},
				{
					text: "Distributor ID",
					value: "dstrId",
					align: "center",
					sortable: false
				},
				{
					text: "City",
					value: "city",
					align: "center",
					sortable: false
				},
				{
					text: "State",
					value: "state",
					align: "center",
					sortable: false
				},
				{
					text: "View Invoice",
					value: "invoiceId",
					align: "center",
					sortable: false
				},
				{
					text: "Download Invoice",
					value: "invoiceId",
					align: "center",
					sortable: false
				}
			],
			viewInvoiceModal: false,
			invoicePath: "",
			activeTab: "tab-0",
			tabs: [{ name: "Download Flow" }, { name: "Upload Flow" }]
		};
	},
	computed: {
		...mapState({
			states: state => state.common.states
		}),
		filterYears() {
			return [2021, 2022];
			// const currentYear = new Date().getFullYear();
			// return [currentYear - 1, currentYear];
		},
		filterMonths() {
			return MONTHS;
			// return MONTHS.slice(0, new Date().getMonth());
		}
	},
	methods: {
		getInvoices() {
			if (this.isInvoiceFetching) {
				return;
			}
			this.isInvoiceFetching = true;
			this.$store
				.dispatch(FETCH_DSTR_PENDING_SUPPORT_ENTRIES.dispatch, {
					month:
						MONTHS.findIndex(
							month => month === this.selectedMonth
						) + 1,
					year: this.selectedYear
				})
				.then(data => {
					this.approvedInvoices = data || [];
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isInvoiceFetching = false;
				});
		},
		viewInvoice(item) {
			this.viewInvoiceModal = true;
			this.invoicePath = item.url;
		},
		downloadInvoice(item) {
			__fileDownload(item.url);
		},
		downloadPdf() {
			__fileDownload(this.invoicePath);
		},
		closeInvoiceModal() {
			this.viewInvoiceModal = false;
			this.invoicePath = "";
		}
	}
};
</script>

<style lang="scss"></style>
